import { render } from "./GenericEntityAttribute.vue?vue&type=template&id=2f5fbaa6&scoped=true"
import script from "./GenericEntityAttribute.vue?vue&type=script&lang=js"
export * from "./GenericEntityAttribute.vue?vue&type=script&lang=js"

import "./GenericEntityAttribute.vue?vue&type=style&index=0&id=2f5fbaa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5fbaa6"]])

export default __exports__